import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "", once = true }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-12%" }}
    transition={{ duration: 1.1, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

// Masked line-by-line reveal. `trigger` = "load" animates on mount, else on scroll into view.
export const LineReveal = ({ lines, className = "", lineClassName = "", delay = 0, trigger = "view" }) => {
  const anim =
    trigger === "load"
      ? { animate: { y: "0%" } }
      : { whileInView: { y: "0%" }, viewport: { once: true, margin: "-10%" } };
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden">
          <motion.span
            className={"block will-change-transform " + lineClassName}
            initial={{ y: "115%" }}
            {...anim}
            transition={{ duration: 1.1, delay: delay + i * 0.12, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};

export const FadeIn = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0 }}
    whileInView={{ opacity: 1 }}
    viewport={{ once: true, margin: "-8%" }}
    transition={{ duration: 1.4, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);
